import { render, staticRenderFns } from "./HomepageTopx.vue?vue&type=template&id=c9666f8e"
import script from "./HomepageTopx.vue?vue&type=script&lang=js"
export * from "./HomepageTopx.vue?vue&type=script&lang=js"
import style0 from "./HomepageTopx.vue?vue&type=style&index=0&id=c9666f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports